export default __webpack_public_path__ + "static/media/ClearIcon.4223b30e.svg";